import { render } from "./AIReportSummary.vue?vue&type=template&id=e663ac0c"
import script from "./AIReportSummary.vue?vue&type=script&lang=js"
export * from "./AIReportSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__